declare const rybConnectForm: {};

$(async () => {
  try {
    const form = document.querySelectorAll(".ryb-connect-crm-form");
    form?.forEach((form) => {
      const formFields = form.querySelectorAll(".wpcf7-form-control");
      if (formFields && formFields.length) {
        for (let i = 0; i < formFields.length; i++) {
          const field = formFields[i] as
            | HTMLInputElement
            | HTMLSelectElement
            | HTMLTextAreaElement;

          const fieldName = field?.getAttribute("name");
          if (fieldName) {
            (rybConnectForm as any)[fieldName] = "";

            field.addEventListener("change", (event) => {
              (rybConnectForm as any)[fieldName] = (
                event?.target as any
              )?.value;
            });
          }
        }
      }
    });
  } catch (error) {
    console.error("Error with form tracker: ", error);
  }
});
